import { compose, css } from '@wrisk/styled-system'
import {
  LinkAnchor,
  TypoSizeProps,
  typoSizes,
  useModal,
  withDefaultProps,
} from '@wrisk/ui-components'
import React, { FunctionComponent, ReactNode, useCallback } from 'react'
import styled from 'styled-components'

import { HelpLinkIFrame } from './HelpLinkIFrame'

export interface HelpLinkProps extends TypoSizeProps {
  linkText: ReactNode
  link: string
  isOpenModal?: boolean
  className?: string
}

const Component: FunctionComponent<HelpLinkProps> = ({
  link,
  linkText,
  className,
  isOpenModal = true,
  ...props
}) => {
  const modal = useModal()

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      // If the link is nested within a parent element like a checkbox label
      e.stopPropagation()

      if (isOpenModal) {
        e.preventDefault()
        modal.show({
          content: <HelpLinkIFrame src={link} />,
          variant: 'iframe',
        })
      }
    },
    [isOpenModal, link, modal],
  )

  return (
    <LinkAnchor
      variant='standalone'
      target='_blank'
      className={className}
      href={link}
      onClick={handleClick}
      {...props}
    >
      {linkText}
    </LinkAnchor>
  )
}

const defaultProps = withDefaultProps<HelpLinkProps>({
  typoSize: 'sm',
})

export const HelpLink = styled(Component).attrs<HelpLinkProps>(defaultProps)(
  css({
    color: 'hyperlink',
    fontFamily: 'buttons',
    fontWeight: 'bold',
  }),
  compose(typoSizes),
)
